var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "C_BG_wave",
    d: "M-1.6 446.8l.2-137.5c17.5-7 37.1-13.9 55.1-19.3 20.8-6.2 42.2-11.5 63.6-15.7 11.2-2.2 22.7-4.1 34-5.7 11.7-1.7 23.6-3 35.5-4.1 18.6-1.7 40.3-2.5 64.3-2.5 22.7 0 48.1.8 75.7 2.2 25.9 1.4 54.5 3.5 84.8 6.2 28.3 2.5 59 5.7 91.4 9.4 29.8 3.4 61.9 7.4 95.4 11.8 57.3 7.6 120.3 16.7 192.6 27.8 62.8 9.7 123.8 19.5 177.7 28.2H969l7 1.1c55 8.9 111.2 16 167.1 21.2 33.2 3.1 66.6 5.5 99.1 7.1 35.9 1.8 71.6 2.7 106.1 2.7 20.4 0 40.9-.3 60.8-.9 20.8-.7 41.6-1.7 61.7-3 21-1.4 42-3.2 62.2-5.3 21.1-2.2 42-4.9 62.3-7.9 44.6-6.6 90.6-12.9 136.9-18.7 43.1-5.4 126.2-13.2 159.4-15 34-1.8 98.9-.6 98.9-.6h10.2v117.6l-2002.3.9z",
    id: "linka"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSimple);
export default __webpack_public_path__ + "static/media/waveSimple.1b1a1794c2b8ae4e140ad904ffa9b0e6.svg";
export { ForwardRef as ReactComponent };